import React, { createContext, useContext, useReducer } from 'react'
import { parsePrice } from '../utils/parsePrice'

const CartContext = createContext(null)

const initialState = {
  items: [],
}

function cartReducer(state, action) {
  switch (action.type) {
    case 'ADD_ITEM': {
      const incoming = action.payload

      const existing = state.items.find(
        (i) => i.id === incoming.id
      )

      if (existing) {
        return {
          ...state,
          items: state.items.map((i) =>
            i.id === incoming.id
              ? { ...i, quantity: i.quantity + 1 }
              : i
          ),
        }
      }

      return {
        ...state,
        items: [...state.items, { ...incoming, quantity: 1 }],
      }
    }

    case 'REMOVE_ITEM': {
      const { id } = action.payload

      return {
        ...state,
        items: state.items
          .map((i) =>
            i.id === id
              ? { ...i, quantity: i.quantity - 1 }
              : i
          )
          .filter((i) => i.quantity > 0),
      }
    }

    case 'CLEAR_CART':
      return initialState

    default:
      return state
  }
}

const getItemTotalPrice = (item) => {
  let total = parsePrice(item.price)

  const opt = item.options ?? {}



  return total * item.quantity
}

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState)

  const addItem = (item) =>
    dispatch({ type: 'ADD_ITEM', payload: item })

  const removeItem = (payload) =>
    dispatch({ type: 'REMOVE_ITEM', payload })

  const clearCart = () =>
    dispatch({ type: 'CLEAR_CART' })

  const totalItems = state.items.reduce(
    (sum, i) => sum + i.quantity,
    0
  )

  const totalPrice = state.items.reduce(
    (sum, item) => sum + getItemTotalPrice(item),
    0
  )

  return (
    <CartContext.Provider
      value={{
        items: state.items,
        addItem,
        removeItem,
        clearCart,
        totalItems,
        totalPrice,
        getItemTotalPrice,
      }}
    >
      {children}
    </CartContext.Provider>
  )
}

export const useCart = () => {
  const ctx = useContext(CartContext)
  if (!ctx) throw new Error('useCart must be used within CartProvider')
  return ctx
}